import { useV2GetPsaProjectPhasesQuery } from "@generated";
import { Opt } from "../../types/PsaProject";

const toOpts = (d?: { id?: any; name?: string }[]): Opt[] =>
  (d ?? []).map((r) => ({ value: String(r.id), label: r.name ?? "" }));

export const usePsaProjectPhases = (
  integrationId: string,
  psaProjectId: string
) => {
  const { data, isFetching } = useV2GetPsaProjectPhasesQuery(
    { id: integrationId, projectId: psaProjectId },
    { skip: !psaProjectId }
  );
  return { phases: toOpts(data?.data), isFetching };
};
